import { useRef } from 'react';
import { useSearchParams } from 'react-router';
import { join, useLightContext } from 'light-component';
import { Space } from 'antd';
import { Box } from '../../../box';
import { Button } from '../../../button';
import { useTranslation } from '../../../i18n';
import { service as widget } from '../service';
import styles from '../style.module.less';
import { Highlighter } from '../../component';
import { Signature, type SignatureRef } from './signature';
import type { UploadSignatureResult } from '../../types';
import type { ShotEyesSignatureProps } from './types';

export function ShotEyesSignatureInputMode(props: ShotEyesSignatureProps): React.ReactElement {
  const [params] = useSearchParams();
  const signature = useRef<SignatureRef | null>(null);
  const [t] = useTranslation();

  const { emitter } = useLightContext();

  async function handleOk(): Promise<void> {
    const value = signature.current?.getBase64();
    if (value == null) {
      return;
    }

    // input 模式下，租户 ID 必须在 url 中传递
    const code = params.get('code');
    if (code == null) {
      return;
    }

    // 上传签名
    emitter.trigger('onSignatureUpload', {
      base64: value,
      code,
      callback: (result: UploadSignatureResult) => {
        props.onPropsChange?.({ value: result.key });
      }
    });
  }

  function handleClear(): void {
    signature.current?.clear();
    props.onPropsChange?.({ value: undefined });
  }

  return (
    <Box className={styles.inputBox} style={{ marginLeft: widget.getIndent(props.path, 0.7) }}>
      <Box className={join(styles.subject)}>
        <Highlighter
          title={props.title}
          keyword={props.keyword}
          require={props.validator === 'required'}
          className={styles.title}
        />
      </Box>
      <Box className={styles.input}>
        <Box className={styles.canvasContainer}>
          <Signature {...props} ref={signature} height={200} />
          <Space className={styles.action}>
            <Button size='small'
              label={t('清除')}
              onClick={handleClear}
              disabled={props.readonly === true}
              autoInsertSpace={false}
            />
            <Button size='small'
              label={t('保存')}
              onClick={handleOk}
              disabled={props.readonly === true}
              autoInsertSpace={false}
            />
          </Space>
        </Box>
      </Box>
    </Box>
  );
}
